import * as React from "react";
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 28452 28452"
    {...props}
  >
    <path
      d="M8769 974h10914c4287 0 7794 3508 7794 7795v10914c0 4287-3507 7794-7794 7794H974V8769c0-4287 3508-7795 7795-7795z"
      style={{
        fill: "none",
        stroke: "#2b2a29",
        strokeWidth: 1948.75,
      }}
      className="stroke1"
    />
  </svg>
);
export default SvgComponent;
